module.exports = __webpack_public_path__ + "static/media/cleaning.78bd2e31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/other/cleaning.svg
// module id = 887
// module chunks = 0